<template>
    <v-list-item link class="simple-job-list-item px-2" @click="$emit('click')">
        <v-row no-gutters align="center" class="w-100">
            <v-col cols="12" md="4" class="py-2 pr-md-2">
                <v-list-item-title class="font-weight-regular">
                    <b class="mr-1">{{ item.Order && item.Order.Id || 'S' + item.Id }}</b> {{ customertext }}
                </v-list-item-title>
                <v-list-item-title>
                    <JobTypeChip :typeId="item.JobType.Id" :typeName="item.JobType.Name" class="mt-1 mb-1" />
                </v-list-item-title>
            </v-col>

            <v-col cols="12" md="4" class="job-address py-1 py-md-2 pr-md-2">
                <v-list-item-subtitle v-if="showAddressColumn" @click.stop="">
                    <v-btn variant="text" small :color="item.JobStatus.Id < 50 ? 'primary' : ''" class="px-0 address-btn"
                        :href="Address?.mapslink" :target="'_blank'">
                        <v-icon size="13">mdi-map-marker</v-icon>
                        {{ addresstext }}
                    </v-btn>
                </v-list-item-subtitle>
            </v-col>

            <v-col cols="10" md="3" class="py-1 py-md-2">
                <div class="time-column">
                    <AppointmentSubtitle v-if="item.JobStatus.Id < 50" :appointments="item.Appointments" />
                    <v-list-item-subtitle v-else>
                        <i>Finished {{ completedDate }}</i>
                    </v-list-item-subtitle>
                </div>
            </v-col>

            <v-col cols="2" md="1" class="d-flex justify-end align-center py-1 py-md-2">
                <v-icon class="chevron">mdi-chevron-right</v-icon>
            </v-col>
        </v-row>
    </v-list-item>
</template>


<script>
import AppointmentSubtitle from './AppointmentSubtitle.vue';
import JobTypeChip from '../JobTypeChip.vue';

export default {
    name: 'SimpleJobListItem',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    components: {
        AppointmentSubtitle,
        JobTypeChip,
    },

    data() {
        return {};
    },

    methods: {},

    computed: {
        completedDate() {
            if (!this.item.CompletedDate) {
                return '';
            } else {
                return new Date(this.item.CompletedDate).toLocaleString();
            }
        },

        Address() {
            if (this.item.CustomerDeliveryAdressStreet ||
                this.item.CustomerDeliveryAdressZip ||
                this.item.CustomerDeliveryAdressCity ||
                this.item.CustomerDeliveryAdressCountry) {
                var address = {
                    street: this.item.CustomerDeliveryAdressStreet,
                    zip: this.item.CustomerDeliveryAdressZip,
                    city: this.item.CustomerDeliveryAdressCity,
                    country: this.item.CustomerDeliveryAdressCountry
                }
                address.mapslink = `http://maps.google.com/?q=${address.street}, ${address.zip} ${address.city}, ${address.country}`;
                return address;
            }
            else {
                return null;
            }
        },

        addresstext() {
            var addresstext = this.Address ?
                `${this.Address.street}, ${this.Address.zip} ${this.Address.city}, ${this.Address.country}` :
                '';
            return addresstext;
        },
        showAddressColumn() {
            return Boolean(this.addresstext);
        },

        customertext() {
            var name = this.item.Customer.Name;
            return name;
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped>
.simple-job-list-item {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.address-btn {
    text-transform: none;
    max-width: 100%;
}

.address-btn :deep(.v-btn__content) {
    font-weight: 500;
}

:deep(.job-address .v-list-item-subtitle) {
    opacity: 1;
}

.time-column {
    text-align: right;
}

.chevron {
    color: rgba(0, 0, 0, 0.55);
}

@media (max-width: 959px) {
    .time-column {
        text-align: left;
    }
}
</style>